/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getSchoolData = (userId) => {
  return client.get(`/details`);
};

const updateQRCode = (user_id, school_id, user_type) => {
  return client.post("/qr-code/update", { user_id, school_id, user_type });
};

export default {
  getSchoolData,
  updateQRCode,
};
